var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#053b5c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tl_category_delivery_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.51,12.5h-51a7.79,7.79,0,0,0-7.77,7.77V79.73a7.79,7.79,0,0,0,7.77,7.77h51a7.79,7.79,0,0,0,7.77-7.77V20.27A7.79,7.79,0,0,0,75.51,12.5ZM39,56.5l-5.75,6a3.11,3.11,0,0,1-2.27,1h-.27a3.13,3.13,0,0,1-2.33-1.42l-2-3a2,2,0,1,1,3.27-2.18l1.49,2.22,5-5.32A2,2,0,1,1,39,56.5Zm0-13.67-5.75,6.05a3.15,3.15,0,0,1-2.28,1h-.27a3.16,3.16,0,0,1-2.32-1.42l-2-3.05a2,2,0,1,1,3.26-2.18l1.49,2.21,5-5.31A2,2,0,1,1,39,42.83Zm0-13.72-5.75,6a3.13,3.13,0,0,1-2.28,1h-.26a3.12,3.12,0,0,1-2.33-1.41l-2-3.05a2,2,0,0,1,3.27-2.18l1.49,2.21,5-5.31A2,2,0,1,1,39,29.11Zm33,45.1H45.62a2,2,0,0,1,0-3.93H72a2,2,0,0,1,0,3.93Zm0-13.7H45.62a2,2,0,0,1,0-3.93H72a2,2,0,0,1,0,3.93Zm0-13.65H45.62a2,2,0,0,1,0-3.94H72a1.94,1.94,0,0,1,2,2A2,2,0,0,1,72,46.86Zm0-13.72H45.62a2,2,0,0,1,0-3.94H72a2,2,0,0,1,0,3.94Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.a47750a26eabe12abf2edc180771172e.svg";
export { ForwardRef as ReactComponent };